import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'
import Dark from '../views/Dark'
import HomeTwo from '../views/HomeTwo'
import HomeThree from '../views/HomeThree'
import Contact from '../views/Contact.vue'
import About from '../views/About.vue'
import Archive from '../views/Archive.vue'
import fourOfour from '../components/404.vue'
import PostOne from '../components/Posts/PostOne/index.vue'
import PostTwo from '../components/Posts/PostTwo/index.vue'
import PostThree from '../components/Posts/PostThree/index'
import Business from '../components/category/Buisness.vue'
import Entertainment from '../components/category/Entertainment.vue'
import Features from '../components/category/Feature.vue'
import Sports from '../components/category/Sports.vue'
import Trending from '../components/category/Trending.vue'
import Article from '../components/category/Articles.vue'
import Events from '../components/Events/List.vue'
import EventDetail from '../components/Events/PostTwo/index.vue'
import ProfileEvents from '../components/Profile/Events.vue'
import JournalList from '../components/Mag/index.vue'
import JournalDetail from '../components/Mag/detail.vue'
import EventForm from '../components/Events/Form.vue'
import Profile from '../components/Profile/index.vue'
import initPwd from '../components/Profile/InitPwd.vue'
import ResetPwd from '../components/Profile/ResetPwd.vue'
import Manuscripts from '../components/Profile/Manuscripts.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/articles',
    name: 'Articles',
    component: Article
  },
  {
    path: '/articles/:id',
    name: 'ArticleDetail',
    component: PostTwo
  },
  {
    path: '/events',
    name: 'Events',
    component: Events
  },
  {
    path: '/events/:id',
    name: 'EventDetail',
    component: EventDetail
  },
  {
    path: '/events/:id/form',
    name: 'EventForm',
    component: EventForm
  },
  {
    path: '/profile/events',
    name: 'ProfileEvents',
    component: ProfileEvents
  },
  {
    path: '/journals',
    name: 'JournalList',
    component: JournalList
  },
  {
    path: '/journals/:id',
    name: 'JournalDetail',
    component: JournalDetail
  },
  {
    path: '/dark',
    name: 'Dark',
    component: Dark
  },
  {
    path: '/home-two',
    name: 'HomeTwo',
    component: HomeTwo
  },
  {
    path: '/home-three',
    name: 'HomeThree',
    component: HomeThree
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/about-us',
    name: 'About',
    component: About
  },
  {
    path: '/archive',
    name: 'Archive',
    component: Archive
  },
  {
    path: '/404',
    name: '404',
    component: fourOfour
  },
  {
    path: '/posts/postOne',
    name: 'PostOne',
    component: PostOne
  },
  {
    path: '/posts/posttwo',
    name: 'PostTwo',
    component: PostTwo
  },
  {
    path: '/posts/postthree',
    name: 'PostThree',
    component: PostThree
  },
  {
    path: '/business',
    name: 'Business',
    component: Business
  },
  {
    path: '/entertainment',
    name: 'Entertainment',
    component: Entertainment
  },
  {
    path: '/features',
    name: 'Features',
    component: Features
  },
  {
    path: '/sports',
    name: 'Sports',
    component: Sports
  },
  {
    path: '/trending',
    name: 'Trending',
    component: Trending
  },  
  {
    path: '/resetpwd',
    name: 'ResetPwd',
    component: ResetPwd
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/initpwd',
    name: 'InitPwd',
    component: initPwd
  },
  {
    path: '/manuscripts',
    name: 'Manuscripts',
    component: Manuscripts
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
